import { PulseWindow } from '@pulse/browser-shared';

export interface StreamStats {
    size?: number | undefined;
    start: number;
    end: number;
    cancelled: boolean;
}

export function valueSize(
    v:
        | Document
        | Blob
        | BufferSource
        | FormData
        | URLSearchParams
        | string
        | Headers
        | Record<string, string>
        | null
        | undefined,
    win: PulseWindow,
): number | undefined {
    try {
        if (typeof v === 'undefined' || v === null || v === '') {
            return 0;
        }

        if (typeof v === 'string') {
            return new win.Blob([v]).size;
        }

        if (v instanceof win.Blob) {
            return v.size;
        }

        if (
            (v instanceof win.ArrayBuffer || win.ArrayBuffer.isView(v)) &&
            typeof v.byteLength === 'number'
        ) {
            return v.byteLength;
        }

        if (v instanceof win.URLSearchParams) {
            return valueSize(v.toString(), win);
        }

        // eslint-disable-next-line no-empty
    } catch {}

    return undefined;
}
